import { useEcho } from '@laravel/echo-vue';
import { AppStore } from '@apparatix/stores/AppStore';
import { useOpportunityStore } from '@apparatix/stores/useOpportunityStore';

export type OpportunityStatusUpdatedPayload = {
  opportunityId: number;
  status: string;
  statusId?: number;
};

export const useOpportunityStatusSync = (enabled = true) => {
  const store = useOpportunityStore();

  if (!enabled) {
    return;
  }

  const channelName = `tenants.${AppStore.tenantId}.opportunities`;
  if (!AppStore.tenantId) return;

  useEcho<OpportunityStatusUpdatedPayload>(
    channelName,
    'OpportunityStatusUpdated',
    data => {
      const opportunity = store.opportunities['Opportunity'].find(item => item.id === data.opportunityId);
      if (!opportunity) return;

      const statusId = data.statusId
        ?? store.options['Opportunity'].possibleStatuses.find(status => status.status === data.status)?.id
        ?? opportunity.statusId;

      opportunity.status = data.status;
      opportunity.statusId = statusId;
      opportunity.swimlaneId = statusId;
      store.updateOpportunity('Opportunity', { ...opportunity });

      if (store.selectedOpportunity['Opportunity']?.opportunity?.id === data.opportunityId) {
        store.selectedOpportunity['Opportunity'].opportunity.status = data.status;
        store.selectedOpportunity['Opportunity'].opportunity.statusId = statusId;
        store.selectedOpportunity['Opportunity'].opportunity.swimlaneId = statusId;
      }
    },
  );
};
